import React from 'react'
import { Mutation } from 'react-apollo'

const withMutate = mutation => Component => props => (
  <Mutation mutation={mutation}>
    {mutate => <Component {...props} mutate={mutate} />}
  </Mutation>
)

export default withMutate



// WEBPACK FOOTER //
// ./src/components/withMutate.js